var map = {
	"./三種牡丹餅.jpg": 92935,
	"./中華拉麵.jpg": 50635,
	"./乾燒明蝦.jpg": 22707,
	"./優酪乳.jpg": 78471,
	"./印度奶茶.jpg": 55763,
	"./可可亞.jpg": 59307,
	"./咖哩飯.jpg": 19841,
	"./咖啡.jpg": 77862,
	"./咖啡布丁.jpg": 11330,
	"./地瓜燒.jpg": 12192,
	"./堅果瑪芬蛋糕.jpg": 39809,
	"./墨西哥玉米湯餅.jpg": 20262,
	"./大碗海鮮抓飯.jpg": 67718,
	"./天婦羅.jpg": 68008,
	"./奶油培根蛋黃麵.jpg": 7710,
	"./奶油燉菜.jpg": 23177,
	"./奶茶.jpg": 8889,
	"./巧克力瑪芬蛋糕.jpg": 4300,
	"./巧克力蛋糕.jpg": 33532,
	"./巧克力餅乾.jpg": 33474,
	"./巨大海鮮披薩.jpg": 88008,
	"./布丁.jpg": 75962,
	"./布朗尼蛋糕.jpg": 23579,
	"./希臘檸檬湯.jpg": 12560,
	"./披薩.jpg": 38524,
	"./拉明頓蛋糕.jpg": 97913,
	"./拌飯.jpg": 227,
	"./拿波里水煮魚.jpg": 39465,
	"./提拉米蘇.jpg": 24128,
	"./摩卡.jpg": 1705,
	"./旗魚壽司.jpg": 8944,
	"./日式拿坡里義大利麵.jpg": 60860,
	"./日式炒牛蒡.jpg": 23639,
	"./日式炸浸蔬菜.jpg": 16352,
	"./日式煮魚.jpg": 99146,
	"./日式燉菜.jpg": 97917,
	"./日式白湯鍋.jpg": 16130,
	"./日式蔬菜豆腐湯.jpg": 30389,
	"./普羅旺斯燉菜.jpg": 16770,
	"./杏仁餅乾.jpg": 81359,
	"./松茸炊飯.jpg": 86461,
	"./果醬三明治.jpg": 31075,
	"./柳橙汁.jpg": 41663,
	"./栗子最中餅.jpg": 14101,
	"./栗子飯.jpg": 67160,
	"./椰子汁.jpg": 29659,
	"./楓糖瑪芬蛋糕.jpg": 67734,
	"./櫻桃冷湯.jpg": 81027,
	"./歐姆蛋.jpg": 19475,
	"./水果歐蕾.jpg": 58989,
	"./水果沙拉.jpg": 8028,
	"./水果蛋糕.jpg": 51861,
	"./法式吐司.jpg": 67402,
	"./法式煎蔬菜.jpg": 38478,
	"./法式燉菜湯.jpg": 8971,
	"./法式鹹派.jpg": 33790,
	"./泡菜.jpg": 55260,
	"./泡菜鍋.jpg": 96875,
	"./泰式咖哩蟹.jpg": 54882,
	"./泰式涼拌冬粉沙拉.jpg": 92200,
	"./泰式炸蝦吐司.jpg": 57961,
	"./泰式酸辣湯.jpg": 25279,
	"./泰式酸辣鯰魚湯.jpg": 29995,
	"./洋菇高麗菜捲.jpg": 54937,
	"./洋蔥拌炒馬鈴薯.jpg": 46608,
	"./洋蔥麵包.jpg": 44378,
	"./海鮮蓋飯.jpg": 22160,
	"./烤大雀鱔.jpg": 40524,
	"./烤蘋果.jpg": 86566,
	"./烤魚.jpg": 36932,
	"./焗烤洋蔥湯.jpg": 75370,
	"./焗烤通心粉.jpg": 20458,
	"./熱牛奶.jpg": 28151,
	"./燉馬鈴薯.jpg": 10481,
	"./玉米麵包.jpg": 57562,
	"./瑞士起司火鍋.jpg": 15737,
	"./田園野菇派.jpg": 57627,
	"./番茄汁.jpg": 62170,
	"./異國風味咖哩.jpg": 75949,
	"./白醬義大利麵.jpg": 37064,
	"./白飯.jpg": 99037,
	"./碗豆燉飯.jpg": 7217,
	"./秋葵湯.jpg": 24589,
	"./糖漬水果.jpg": 59377,
	"./紅豆麻糬湯.jpg": 71421,
	"./綜合沙拉.jpg": 2603,
	"./綜合蔬菜湯.jpg": 74416,
	"./綠色蔬菜濃湯.jpg": 48570,
	"./羅宋湯.jpg": 84702,
	"./美式鬆餅.jpg": 83593,
	"./義大利漁夫麵.jpg": 33544,
	"./義式奶酪.jpg": 66541,
	"./義式烤扁鱈.jpg": 2744,
	"./義式番茄起司沙拉.jpg": 73890,
	"./義式蔬菜湯.jpg": 58729,
	"./艾草大福.jpg": 57414,
	"./芒果汁.jpg": 48536,
	"./芒果糯米飯.jpg": 49938,
	"./芬蘭甜菜沙拉.jpg": 82059,
	"./茄汁焗豆.jpg": 40215,
	"./茶.jpg": 29393,
	"./草莓大福.jpg": 41558,
	"./草莓奶油蛋糕.jpg": 6957,
	"./草莓牛奶.jpg": 28677,
	"./荷包蛋.jpg": 96827,
	"./菠菜泥優格沙拉.jpg": 7420,
	"./葡萄汁.jpg": 42109,
	"./葡萄牙海鮮銅鍋料理.jpg": 32920,
	"./蒙布朗.jpg": 5016,
	"./蒜味辣椒義大利麵.jpg": 52846,
	"./蔬菜三明治.jpg": 2835,
	"./蔬菜汁.jpg": 85990,
	"./蔬菜沙拉.jpg": 62229,
	"./蔬食披薩.jpg": 36488,
	"./薩赫蛋糕.jpg": 59437,
	"./蘋果汁.jpg": 80996,
	"./蚌殼湯.jpg": 29931,
	"./蛤蜊巧達濃湯.jpg": 3005,
	"./蜂蜜優格.jpg": 25227,
	"./蜂蜜地瓜燒.jpg": 71547,
	"./蜂蜜布丁.jpg": 4079,
	"./蜂蜜拿鐵.jpg": 26970,
	"./蜂蜜檸檬汁.jpg": 66545,
	"./蜂蜜牛奶可可.jpg": 59971,
	"./西班牙冷湯.jpg": 7055,
	"./西班牙式鐵板煎菇.jpg": 65842,
	"./西班牙杏仁糕點.jpg": 60235,
	"./西班牙烤大蔥.jpg": 27812,
	"./西班牙風醃漬沙丁魚.jpg": 2320,
	"./西班牙香蒜湯.jpg": 59435,
	"./豆子沙拉.jpg": 51139,
	"./豆皮烏龍麵.jpg": 54598,
	"./起司蛋糕.jpg": 69103,
	"./酥炸鮪魚塊.jpg": 45439,
	"./酸辣湯.jpg": 51098,
	"./酸黃瓜.jpg": 98832,
	"./醃漬小魚.jpg": 87659,
	"./醃漬香菇.jpg": 66469,
	"./雞蛋三明治.jpg": 97859,
	"./雞蛋沙拉.jpg": 54074,
	"./青醬義大利麵.jpg": 16419,
	"./韓式年糕湯.jpg": 10580,
	"./餅乾.jpg": 25515,
	"./香料咖哩炒秋葵.jpg": 74713,
	"./香草茶.jpg": 22528,
	"./香蕉牛奶.jpg": 84337,
	"./馬賽魚湯.jpg": 90273,
	"./馬鈴薯沙拉.jpg": 94720,
	"./鮪魚三明治.jpg": 31209,
	"./鯛魚生魚片.jpg": 58329,
	"./鰻魚飯.jpg": 11628,
	"./麵包.jpg": 56026,
	"./麻辣螯蝦.jpg": 86345,
	"./黃色蔬菜濃湯.jpg": 5291,
	"./黃豆粉烤年糕吐司.jpg": 86142,
	"./黑森林蛋糕.jpg": 65531,
	"./龍宮湯.jpg": 27491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32260;